/**************************************************
 * Nombre:       Tarjeta_Estudia
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, IconButton, Typography} from "@mui/material";
import {NEGRITA} from "../../Constantes";
import {PlayCircle} from '@mui/icons-material'
import {useResponsive} from "../../Modulo_responsive/Hooks/useResponsive";

const Tarjeta_Estudia = ({item}) => {
    const {sCell} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                backgroundColor: item.color,
                p: sCell ? 3 : 6,
                color: '#fff'
            }}
        >

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 7}}>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Typography sx={{fontFamily: NEGRITA, fontSize: 40, fontWeight: 600, lineHeight: 1.1, height: sCell ? 'auto' : 80,
                        color: '#fff'}}>{item.nombre}</Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start',mt: 2}}>
                    <Typography
                        sx={{fontSize: 16, fontWeight: 400, lineHeight: 1.4, height: 90,
                            color: '#fff'}}>{item.descripcion}</Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 4}}>
                    <IconButton sx={{
                        backgroundColor: '#fff',
                    }}>

                        <PlayCircle/>

                    </IconButton>
                </Grid>


            </Grid>

            <Grid
                container
                justifyContent={ sCell ? 'flex-end' : 'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 5}}
                sx={{ml: sCell ? 0 : -10, mb: sCell ? -3 :  -8,mt: sCell ? -8 : -13}}
            >

                <img src={item.img} width={'auto'} height={ sCell ? 200 : 410}/>

            </Grid>


        </Grid>
    )

}
export default Tarjeta_Estudia